module.exports = __webpack_public_path__ + "img/IMG-20200609-WA0162.795bfca2.jpg";